import { useContext } from "react";
import { UserContext } from "components/context/UserProvider";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/history`;

export const keyName = "History";

export const {
  useGetAll: useAllHistory,
  useGet: useGetHistory,
  useCreate: useCreateHistory,
  useUpdate: useUpdateHistory,
  useDelete: useDeleteHistory,
} = apiCrudBuilder(path, keyName);

export const useLogHistory = (content_type_model) => {
  const { user } = useContext(UserContext);
  const { mutateAsync } = useCreateHistory();

  const handleLog = (object_id) => {
    mutateAsync({
      content_type_model: content_type_model,
      object_id: object_id,
      user: user.id,
    });
  };

  return handleLog;
};
